export default __webpack_public_path__ + "static/media/note.16555a5c.svg";